import logo from '../../../../assets/nav/new-logo-lg-2.svg';
import ProductScenes from '../ProductScenes';
import {
  BannerColumn,
  BannerInner,
  FormColumn,
  FormContent,
  FormFooter,
  FormHeader,
  FormMain,
  HeaderLink,
  OnboardingBlock,
  OnboardingGrid,
  ScenesWrapper,
} from './FlowTemplate.styles';

function FlowTemplate({ children, showRightPanel = true, headerExtra = null }) {
  return (
    <OnboardingBlock>
      <OnboardingGrid $showRightPanel={showRightPanel}>
        <FormColumn>
          <FormHeader>
            <img src={logo} alt="Houdiny" />
            {headerExtra}
          </FormHeader>

          <FormMain>
            <FormContent>{children}</FormContent>
          </FormMain>

          <FormFooter>© {new Date().getFullYear()} Houdiny AI</FormFooter>
        </FormColumn>

        {showRightPanel && (
          <BannerColumn>
            <BannerInner>
              <ScenesWrapper>
                <ProductScenes />
              </ScenesWrapper>
            </BannerInner>
          </BannerColumn>
        )}
      </OnboardingGrid>
    </OnboardingBlock>
  );
}

export default FlowTemplate;
